import axios from 'axios'
import {useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import logo from '../media/Balanz_white_logo.svg'
import { useGlobalContent } from '../context/helpersProvider'
import expiredToken from '../utils/headerAuth'

export const VerifyUser = (props: any) => {
  const history = useNavigate()
  const { setShowToast } = useGlobalContent()

  const [code, setCode] = useState('')
  const [error, setError] = useState('')

  const handleChange = (e: any) => {
    const value = e.target.value
    setCode(value)
  }

  useEffect(() => {
    if (props.location.state === undefined) {
      history('/')
    }
  })

  const verifyEmail = (e: any) => {
    e.preventDefault()
    axios
      .put('/user/validation', {
        email: props.location.state,
        code: code,
      })
      .then((json) => json.data)
      .then((datos) => {
        if (datos.data) {
          history('/request')
        } else {
          setError(datos.message)
        }
      })
      .catch((err) => {
        expiredToken(history, err, setShowToast)
        setError('Something went wrong, please try again')
      })
  }

  return (
    <div className='columns w-row container-log-check'>
      <div className='logocolumn w-col w-col-4 w-col-stack'>
        <img
          src={logo}
          loading='lazy'
          alt='Balanz logo'
          width='600'
          sizes='(max-width: 479px) 63vw, (max-width: 767px) 43vw, (max-width: 991px) 36vw, 23vw'
          className='loginlogo'
        />
      </div>
      <div className='formcolumn w-col w-col-8 w-col-stack'>
        <div className='form w-form'>
          <form
            id='wf-form-verification-code'
            name='wf-form-verification-code'
            data-name='verification-code'
            method='get'
            onSubmit={verifyEmail}
          >
            <h3 className='h2-titles'>New user please check your email</h3>
            <p className='paragraph'>
              Please enter the verification code we just sent to your email (make sure to check your
              spam folder)
            </p>
            <label className='field-label'>Verification code</label>
            <input
              type='text'
              className='text-field approve w-input'
              maxLength={20}
              name='code'
              value={code}
              onChange={handleChange}
              placeholder='Verification code'
              id='verification-code'
              autoComplete="off"
            />
            <p className='alert'>{error} </p>
            <input
              type='submit'
              data-wait=''
              value='Confirm'
              className='button continue w-button'
            />
          </form>
        </div>
      </div>
    </div>
  )
}
